const SHOPIFY_DOMAIN_SUFFIX = ".myshopify.com";
const BIGCOMMERCE_DOMAIN_SUFFIX = ".mybigcommerce.com";
const BIGCOMMERCE_STORE_PREFIX = "store-";

export const normalizeShopifyStoreDomainInput = (rawStoreUrl: string) => {
  const normalizedInput = rawStoreUrl
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/^\/+/, "");

  const host = normalizedInput.split(/[/?#]/)[0]?.replace(/\.+$/, "") || "";

  if (!host) {
    return "";
  }

  if (host.endsWith(SHOPIFY_DOMAIN_SUFFIX)) {
    return host;
  }

  return `${host}${SHOPIFY_DOMAIN_SUFFIX}`;
};

export const normalizeStoreUrlTextInput = (
  rawStoreUrl: string,
  platform?: string | null,
) => {
  const normalizedInput = rawStoreUrl
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/^\/+/, "");

  let host = normalizedInput.split(/[/?#]/)[0]?.replace(/\.+$/, "") || "";

  if (!host) {
    return "";
  }

  if (platform === "Shopify") {
    return host.endsWith(SHOPIFY_DOMAIN_SUFFIX)
      ? host.slice(0, -SHOPIFY_DOMAIN_SUFFIX.length)
      : host;
  }

  if (platform === "BigCommerce") {
    if (host.endsWith(BIGCOMMERCE_DOMAIN_SUFFIX)) {
      host = host.slice(0, -BIGCOMMERCE_DOMAIN_SUFFIX.length);
    }

    return host.startsWith(BIGCOMMERCE_STORE_PREFIX)
      ? host.slice(BIGCOMMERCE_STORE_PREFIX.length)
      : host;
  }

  return host;
};
